__webpack_require__.p = "/globalsearch/_next/";